var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",on:{"switch":_vm.handleSwitch,"next":function($event){return _vm.$emit('next')},"step":(step) => _vm.$emit('step', step)}})
}
var staticRenderFns = []

export { render, staticRenderFns }